import styled, { css } from 'styled-components';
import { themeGet } from '../../foundation/theme/themeGet/get.js';

function animatePopover(state) {
  switch (state) {
    case 'hidden':
      return css(["display:none;transform:translate(0,0.25rem);opacity:0;"]);
    case 'entering':
    case 'leaving':
      return css(["transform:translate(0,0.25rem);opacity:0;display:flex;"]);
    default:
      return css(["transform:translate(0,0);opacity:1;display:flex;"]);
  }
}
var Container = styled.div.withConfig({
  displayName: "Container",
  componentId: "sc-1gl9kpg-0"
})(["display:flex;flex-direction:column;position:relative;overflow:hidden;z-index:", ";border-radius:", ";background-color:", ";box-shadow:", ";padding:", ";", ";transition:opacity ", " ", ",transform ", " ", ";"], themeGet('zIndex.popover'), themeGet('borderRadius.md'), themeGet('colors.gray.0'), themeGet('dropShadow.200'), function (props) {
  return themeGet("spacing." + props.$padding);
}, function (props) {
  return animatePopover(props.$state);
}, themeGet('motion.duration.fast'), themeGet('motion.easing.standard'), themeGet('motion.duration.fast'), themeGet('motion.easing.standard'));

export { Container };
